import(/* webpackMode: "eager" */ "/app/node_modules/katex/dist/katex.css");
;
import(/* webpackMode: "eager", webpackExports: ["PageClient"] */ "/app/src/app/(training)/(terry)/task/terry/[name]/submit/page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/components/link.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/statement/markdown.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PdfStatement"] */ "/app/src/components/statement/pdf.tsx");
